interface IExamRequestsProps {
    isEditMode: boolean;
    isReadOnly: boolean;
    consultations: JSX.Element[];
    openConsultationRequestPopup: (consultationId: string) => void;
}

function ConsultationRequests(props: IExamRequestsProps): JSX.Element {
    const canQuickSignDocuments = cacheStore.ClinicSettings.EnableQuickDocumentSigning && !props.isReadOnly && props.consultations.length > 0;

    return (
        <tr>
            <td className="c1 bottom-pad">
                <div className={canQuickSignDocuments ? "margin-md-top" : ""}>
                    <strong>{cacheStore.GetString("ConsultationRequestLabel")}</strong>
                </div>
            </td>
            <td className="c2">
                <div className="tb-row tb">
                    <div className={`add-btn-column ${canQuickSignDocuments ? "padding-md-top" : ""}`}>
                        {props.isEditMode ? <a onClick={() => props.openConsultationRequestPopup(null)} data-cy="consultationsRequests-addRequest">[+]</a> : ""}
                    </div>
                    <div className="note-items-column" data-cy="consultationsRequests-request">
                        {!isArrayNullOrUndefinedOrEmpty(props.consultations) ? props.consultations : ""}
                    </div>
                </div>
            </td>
        </tr>
    );
}

export { ConsultationRequests };
